import LoadingSkeleton from '../../../cmp/LoadingSkeleton';
import React from 'react';

const Page = React.lazy(()=>import('../AffiliateSalesDetails'))

export default function LazyAffiliateSaleDetails(props){
    return <React.Suspense fallback={<LoadingSkeleton height={500} />}>
        <Page {...props} />
    </React.Suspense>
}
